export {
  CoachOverlayProvider,
  ScopedCopilotProvider,
  useCoachOverlayContext,
} from "./CoachOverlayProvider";
export {
  CoachOverlayStep,
  useCoachOverlaySteps,
  type CoachOverlayStepProps,
  type CoachOverlayStepConfig,
} from "./CoachOverlayStep";
